module.exports = __webpack_public_path__ + "img/i_review_write_gr.f469c010.svg";